const _Layout = () => import("@/pages/health/components/_layout.vue");
const _headerLayoutOdbr = () =>
  import("@/pages/health/components/New/_headerLayoutOdbr.vue");
// const ODBAF261_1 = () => import("@/pages/health/views/F2/ODBAF261_1.vue");
// const ODBAF263_1 = () => import("@/pages/health/views/F2/ODBAF263_1.vue");
// const ODBAF266 = () => import("@/pages/health/views/F2/ODBAF266.vue");
const ODBAF2FakeLogin = () =>
  import("@/pages/health/views/F2/ODBAF2FakeLogin.vue");
const ODBAF201 = () => import("@/pages/health/views/F2/ODBAF201.vue");
const ODBAF210 = () => import("@/pages/health/views/F2/ODBAF210.vue");
const ODBAF231 = () => import("@/pages/health/views/F2/ODBAF231.vue");
// const ODBAF234 = () => import("@/pages/health/views/F2/ODBAF234.vue");
// const ODBAF240 = () => import("@/pages/health/views/F2/ODBAF240.vue");
// const ODBAF241 = () => import("@/pages/health/views/F2/ODBAF241.vue");
// const ODBAF242 = () => import("@/pages/health/views/F2/ODBAF242.vue");
// const ODBAF250 = () => import("@/pages/health/views/F2/ODBAF250.vue");
// const ODBAF270 = () => import("@/pages/health/views/F2/ODBAF270.vue");
// const ODBAF271 = () => import("@/pages/health/views/F2/ODBAF271.vue");

// const ODBAY001 = () => import("@/pages/health/views/Y0/ODBAY001");
const ODBAY002 = () => import("@/pages/health/views/Y0/ODBAY002");

const ODBAZ000 = () => import("@/pages/health/views/Z0/ODBAZ000.vue");
const routes = [
  {
    path: "/",
    redirect: "/F2/ODBAF220"
  },
  {
    path: "/health.html",
    redirect: "/F2/ODBAF210"
  },
  {
    path: "/F2",
    name: "F2",
    component: _Layout,
    children: [
      {
        path: "ODBAF2FakeLogin/:id",
        name: "ODBAF2FakeLogin",
        component: ODBAF2FakeLogin
      },
      {
        path: "ODBAF231",
        name: "ODBAF231",
        component: ODBAF231
      }
    ]
  },
  {
    path: "/F2",
    name: "F2New",
    component: _headerLayoutOdbr,
    children: [
      {
        path: "ODBAF201",
        name: "ODBAF201",
        component: ODBAF201
      },
      {
        path: "ODBAF210",
        name: "ODBAF210",
        component: ODBAF210
      }
    ]
  },
  {
    path: "/Y0",
    name: "Y0",
    component: _Layout,
    children: [
      // {
      //   path: "ODBAY001/:encodeJson?",
      //   name: "ODBAY001",
      //   component: ODBAY001
      // },
      {
        path: "ODBAY002",
        name: "ODBAY002",
        component: ODBAY002
      }
    ]
  },
  {
    path: "/Z0",
    name: "Z0",
    component: _Layout,
    children: [
      {
        path: "ODBAZ000",
        name: "ODBAZ000",
        component: ODBAZ000
      }
    ]
  },
  {
    path: "*",
    redirect: "/F2/ODBAF220"
  }
];

export default {
  routes
};
